import React, { Component } from "react";
import { Link } from "react-router-dom";
import Image from "../../../base/features/micro/Image";

class SearchShopCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shopProperties: this.props.shopProperties,
    };
  }
  render() {
    return (
      <div className="container-fluid px-0">
        <Link to={"/" + this.state.shopProperties.uid}>
          <div className="row mx-0 px-0">
            <div className="col-4 px-1 align-self-center">
              <Image
                imageHeight={"95"}
                type={"product"}
                extraClassName={"bg-color-main p-3 w-100 rounded14"}
                imgClassName={
                  "rounded14 w-100 " +
                  (!this.state.shopProperties.cover
                    ? "bg-color-main p-3"
                    : "img-cover")
                }
                imageUri={
                  this.state.shopProperties.cover &&
                  this.state.shopProperties.cover.thumbnail
                }
              />
            </div>
            <div className="col-8 px-1 align-self-center">
              <p className="fs-6 mb-0 fw-bolder">
                {this.state.shopProperties.title}
                {this.state.shopProperties.is_verify && (
                  <img
                    width="15"
                    className="me-1"
                    alt="verify"
                    src={
                      require("../../../base/assets/icons/verify.svg").default
                    }
                  />
                )}
              </p>
              <p className="fs-6 text-muted fw-bold mb-0">
                {this.state.shopProperties.sub_title}
              </p>

              {this.state.shopProperties.categories.length > 0 &&
                this.state.shopProperties.categories.map((category, c) => (
                  <span className="ps-2 d-inline-block fs-6 color-main" key={c}>
                    {category.title}
                  </span>
                ))}
            </div>
          </div>
        </Link>
      </div>
    );
  }
}

export default SearchShopCard;
